import React, { Component } from "react";
import connect from "../../connects/live-chat";

const FAB_POS_STORAGE_KEY = 'chat-fab-pos';

class HubspotChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLoaded: false,
      activeConversation: false,
      chatWidth: "",
      chatHeight: "",
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isMobileView: window.innerWidth <= 768,
    };
    this.eventRef = null;
    this.fallbackTimeout = null;
  }

  updateWindowSize = () => {
    // when resize the window by the user
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    })
    // check mobile view or not
    this.setState({ isMobileView: window.innerWidth <= 768 });

    const fab = document.getElementById("custom-chat-fab");
    if(fab && fab.style){  // if there is hubspot FAB and it has style
      
      const originalRight = fab.style.right ? parseInt(fab.style.right, 10) : 0
      const originalBottom = fab.style.bottom ? parseInt(fab.style.bottom, 10) : 0

      const savedPos = localStorage.getItem(FAB_POS_STORAGE_KEY);
      if(savedPos){ // if there is saved positoin in local storage

        let parsedPos;
        try {
          parsedPos = JSON.parse(savedPos);
        } catch (e) {
          console.error('Failed to parse saved FAB position:', e);
          localStorage.removeItem(FAB_POS_STORAGE_KEY);
          parsedPos = null;
        }

        let top = parsedPos && parsedPos.top !== undefined ? parsedPos.top : 80;
        let left = parsedPos && parsedPos.left !== undefined ? parsedPos.left : 80;
        // when resize the window and fab position is out of window
        if( originalBottom > this.state.windowHeight - 80){
          // assume initial gap as 80px
          top = 80
          localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
            top: top,
            left: left
          }));
          fab.style.bottom = `${this.state.windowHeight - 80}px`
        }
        if( originalRight > this.state.windowWidth - 80 ){
          // assume initial gap as 80px
          left = 80
          localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
            top: top,
            left: left,
          }));
          fab.style.right = `${this.state.windowWidth- 80}px`
        }
      } else {
          localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
              top: this.state.windowHeight - 80,
              left: this.state.windowWidth- 80,
            }));
          fab.style.right = `${this.state.windowWidth - 80}px`
          fab.style.bottom = `${this.state.windowHeight - 80}px`
      }
    }
  }

  componentDidMount() {
    if (this.props.rightSidePage) return;
    
    window.addEventListener('resize', this.updateWindowSize)

    // Inject HubSpot script
    if (
      !document.body.querySelector(
        `script[src="//js.hs-scripts.com/${this.props.portalId}.js"]`
      )
    ) {
      let script = document.createElement("script");
      script.src = `//js.hs-scripts.com/${this.props.portalId}.js`;
      script.async = true;

      script.onload = () => {
        console.log("✅ HubSpot script loaded successfully.");
        this.setState({ hasLoaded: true });
        // after hubspot loading, need to load all including FAB
         this.fallbackTimeout = setTimeout(() => {
          if (window.HubSpotConversations) {
            this.handleHubSpotLoad();
          }
        }, 2000);

      };
      script.onerror = () =>
        console.error("❌ HubSpot script failed to load.");

      document.body.appendChild(script);
      this.scriptElement = script;
    }

    // Inject CSS
    const style = document.createElement("style");
    style.innerHTML = `
      .hide-chat {
        opacity: 0 !important;
        pointer-events: none !important;
      }
      .show-chat {
        opacity: 1 !important;
        
        pointer-events: auto !important;
      }
      #hubspot-messages-iframe-container {
        transition: opacity 0.3s ease, transform 0.3s ease;
      }
        
      @media (max-width: 768px) {
        .hide-chat {
          opacity: 0 !important;
          pointer-events: none !important;
          visibility: hidden !important;
        }
      }
    `;
    document.head.appendChild(style);

  }                                 

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.rightSidePage !== this.props.rightSidePage) {
      this.toggleHubSpotVisibility();
    }

    if (this.state.hasLoaded && !prevState.hasLoaded) {
      this.handleHubSpotLoad();
    }
  }

  componentWillUnmount() {
    window.addEventListener('resize', this.updateWindowSize)
    window.hsConversationsOnReady = [];

    if (this.eventRef && window.HubSpotConversations) {
      window.HubSpotConversations.off("conversationStarted", this.eventRef);
    }

    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.close();
    }

    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
    }
  }

  handleHubSpotLoad = () => {
    if (window.HubSpotConversations) {
      if (window._hsq && this.props.user) {
        window._hsq.push(["identify", { email: this.props.user.email }]);
        window._hsq.push(["trackPageView"]);
      }
  
      this.eventRef = (payload) => {
        this.setState({
          activeConversation: payload.conversation.conversationId,
        });
      };
      window.HubSpotConversations.on("conversationStarted", this.eventRef);

      // ✅ Listen for widget open/close events
      window.HubSpotConversations.on("widgetOpened", () => {
        this.openHandler(true);  // pass true to indicate internal event
      });

      window.HubSpotConversations.on("widgetClosed", () => {
        this.closeHandler(true);  // pass true to indicate internal event
      });

      // ✅ Observe DOM changes to catch the container as soon as it's added
      const observer = new MutationObserver((mutations, obs) => {
        const chat = document.querySelector("#hubspot-messages-iframe-container");
        if (chat) {
          chat.classList.add("hide-chat");
          obs.disconnect(); // ✅ Stop observing once found and hidden
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      
      if(!this.state.isMobileView){
        // when mobile view, there is no need to customize the chat position.

        const tryOpenChat = setInterval(() => {
          if (window.HubSpotConversations && window.HubSpotConversations.widget ) {
            window.HubSpotConversations.widget.open(); // ✅ Automatically opens the chat widget
            clearInterval(tryOpenChat); // ✅ Stop polling
            setTimeout(() => {
              const chat = document.querySelector("#hubspot-messages-iframe-container");
              if(chat){
                // store the width and height of the whole opend widget to the state
                this.setState({chatWidth: chat.offsetWidth, chatHeight: chat.offsetHeight})
              }}, 1000)
          }
        }, 3000);
      }

      // ✅ Proceed to add the custom FAB
      this.injectDraggableFAB();
    }
  };
  
  toggleHubSpotVisibility = () => {
    const fabContainer = document.querySelector(
      "#custom-chat-fab"
    );
    if (fabContainer) {
      if (this.props.rightSidePage) {
        fabContainer.classList.add("hide-chat");
        fabContainer.classList.remove("show-chat");
      } else {
        fabContainer.classList.remove("hide-chat");
        fabContainer.classList.add("show-chat");
      }
    }

    const chatContainer = document.querySelector('#hubspot-messages-iframe-container')
    if (chatContainer) {
      if (this.props.rightSidePage) {
        chatContainer.classList.add("hide-chat");
        chatContainer.classList.remove("show-chat");
      } 
    }

  };

  injectDraggableFAB = () => {
    if (document.getElementById("custom-chat-fab")) return;
  
    const fab = document.createElement("div");
    fab.id = "custom-chat-fab";

    // Replace emoji with an SVG icon (similar to HubSpot's)
    fab.innerHTML = `
       <!-- Chat bubble SVG icon -->
        <svg width="28" height="28" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4H20C21.1 4 22 4.9 22 6V16C22 17.1 21.1 18 20 18H6L2 22V6C2 4.9 2.9 4 4 4Z" />
        </svg>
    `;

    fab.style.cssText = `
      position: fixed;
      bottom: 25px;
      right: 24px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: rgb(223, 0, 21);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 8px rgba(0,0,0,0.3);
      cursor: pointer;
      z-index: 1000;
      user-select: none;
      transition: transform 0.2s ease;
      touch-action: manipulation;
      -webkit-user-select: none;
      -webkit-tap-highlight-color: transparent;
    `;

    fab.addEventListener("mouseenter", () => {
      fab.style.transform = "scale(1.1)";
    });

    fab.addEventListener("mouseleave", () => {
      fab.style.transform = "scale(1)";
    });

  
    const savedPos = localStorage.getItem(FAB_POS_STORAGE_KEY);
    if (savedPos) {
      // set the fab postion with stored position if saved pos in the desired window
      let parsedPos;
      try {
        parsedPos = JSON.parse(savedPos);
      } catch (e) {
        console.error('Failed to parse saved FAB position:', e);
        localStorage.removeItem(FAB_POS_STORAGE_KEY);
        parsedPos = null;
      }
      
      const top = parsedPos && parsedPos.top !== undefined ? parsedPos.top : 80;
      const left = parsedPos && parsedPos.left !== undefined ? parsedPos.left : 80;
      
      if( (top > 0) &&  (top < this.state.windowHeight) && (left < this.state.windowWidth) && (left > 0)){
        fab.style.bottom = `${this.state.windowHeight- top}px`;
        fab.style.right = `${this.state.windowWidth - left}px`;
      }
    }
  
    document.body.appendChild(fab);
    setTimeout(() => fab.blur(), 100);
  
    let offsetX = 0, offsetY = 0, dragging = false;
    let startX = 0, startY = 0, moved = false;
  
    // ✅ Capture `this.openHandler` in a local variable to preserve scope
    const openHandler = this.openHandler;
  
    fab.addEventListener("pointerdown", (e) => {
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      moved = false;
      offsetX = e.clientX - fab.getBoundingClientRect().left;
      offsetY = e.clientY - fab.getBoundingClientRect().top;
      fab.setPointerCapture(e.pointerId);
      fab.style.cursor = "grabbing";
    });
  
    fab.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      let newLeft = e.clientX + offsetX;
      // manual position check whether it's outside of the width
      if (newLeft < 80) newLeft = 80
      if (newLeft > this.state.windowWidth) newLeft = this.state.windowWidth - 25
      
      let newTop = e.clientY + offsetY;
      // manual position check whether it's outside of the height
      if(newTop < 80) newTop = 80
      if(newTop > this.state.windowHeight) newTop = this.state.windowHeight - 25

      fab.style.bottom = `${this.state.windowHeight- newTop}px`;
      fab.style.right = `${this.state.windowWidth - newLeft}px`;
  
      if (Math.abs(e.clientX - startX) > 3 || Math.abs(e.clientY - startY) > 3) {
        moved = true;
      }
    });
  
    fab.addEventListener("pointerup", (e) => {
      dragging = false;
      fab.releasePointerCapture(e.pointerId);
      fab.style.cursor = "grab";
  
      localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
        top: fab.offsetTop,
        left: fab.offsetLeft,
      }));
  
      if (!moved && openHandler) {
        const chat = document.querySelector("#hubspot-messages-iframe-container");
        if (!chat) return;

        if(this.state.isMobileView){
          // Mobile or responsive view (small screen)

          chat.classList.remove("hide-chat");
          chat.classList.add("show-chat");

          openHandler();

          fab.classList.remove("show-chat");
          fab.classList.add("hide-chat");

          return;
        }

        if(this.state.chatHeight)  // only after getting the width and height of the real opend widget
        {
          chat.style.position = "fixed";
          const fabRect = fab.getBoundingClientRect(); // actual position
  
          const fabPostionY = fabRect.top;
          const fabPostionX = fabRect.left;
  
          if (this.state.windowHeight- fabPostionY < this.state.chatHeight - 80) {
            if((fabPostionY - this.state.chatHeight + 80) < -100) // when top position is less than -100, set as 15
              chat.style.top = "15px";
            else
              chat.style.top = (fabPostionY - this.state.chatHeight + 80) + "px";
          } else {
            chat.style.top = fabPostionY - 20 + "px"; 
          }
  
  
          if( fabPostionX > this.state.chatWidth -80){
            chat.style.left = (fabPostionX - this.state.chatWidth + 80) + "px";
          } else {
            chat.style.left = fabPostionX - 20 + "px";
          }
  
  
          chat.style.bottom = "";
          chat.style.right = "";
  
          chat.classList.remove("hide-chat");
          chat.classList.add("show-chat");
    
          openHandler(); // ✅ properly scoped

          fab.classList.remove('show-chat')
          fab.classList.add('hide-chat')
        }  

      }
    });

    fab.addEventListener("pointercancel", (e) => {
      dragging = false;
      fab.releasePointerCapture(e.pointerId);
      fab.style.cursor = "grab";
      fab.blur(); // remove focus
    });
  };
    
  openHandler = (fromHubspot = false) => {
    if (this.state.hasLoaded && window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
  
      if (!fromHubspot) {
        const chat = document.querySelector("#hubspot-messages-iframe-container");
        if (chat) {
          chat.classList.remove("hide-chat");
          chat.classList.add("show-chat");
        }
      }
    }
  };
  
  closeHandler = (fromHubspot = false) => {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.close();
      if (fromHubspot) {
        const fab = document.getElementById("custom-chat-fab");
        if (fab) {
          fab.classList.remove("hide-chat");
          fab.classList.add("show-chat");
        }

        const chat = document.querySelector("#hubspot-messages-iframe-container");
        if (chat) {
          chat.classList.remove("show-chat");
          chat.classList.add("hide-chat");
          
        }
      }
    }
  };
  

  render() {
    return this.props.children({
      hasLoaded: this.state.hasLoaded,
      activeConversation: this.state.activeConversation,
      openHandler: this.openHandler,
      closeHandler: this.closeHandler,
    });
  }
}

class LiveChat extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.rightSidePage !== this.props.rightSidePage;
  }

  render() {
    const { rightSidePage, user } = this.props;
    return (
      <HubspotChat
        portalId="20714277"
        rightSidePage={rightSidePage}
        user={user}
      >
        {({ hasLoaded, activeConversation, openHandler, closeHandler }) => (
          <div></div>
        )}
      </HubspotChat>
    );
  }
}

export default connect(LiveChat);



// WEBPACK FOOTER //
// ./src/web/components/live-chat.jsx